document.addEventListener("DOMContentLoaded", () => {
	AOS.init({
		startEvent: 'load',
		offset: 50,
		duration: 1000,
		once: true
	})
	const button = document.querySelector('.header__hamburger');
	const nav = document.querySelector('.header__nav');
	nav.querySelectorAll('.menu li a').forEach(a => {
		a.addEventListener('click', () => {
			if (nav.classList.contains('open')) {
				nav.classList.toggle('open')
				button.classList.toggle('open')
			}
		})
	})
	button.addEventListener('click', () => {
		nav.classList.toggle('open')
		button.classList.toggle('open')
	})
	class Accordion {
		// The default constructor for each accordion
		constructor(el) {
			// Store the <details> element
			this.el = el;
			// Store the <summary> element
			this.summary = el.querySelector('summary');
			// Store the <div class="content"> element
			this.content = el.querySelector('.content');

			// Store the animation object (so we can cancel it, if needed)
			this.animation = null;
			// Store if the element is closing
			this.isClosing = false;
			// Store if the element is expanding
			this.isExpanding = false;
			// Detect user clicks on the summary element
			this.summary.addEventListener('click', (e) => this.onClick(e));
		}

		// Function called when user clicks on the summary
		onClick(e) {
			// Stop default behaviour from the browser
			e.preventDefault();
			// Add an overflow on the <details> to avoid content overflowing
			this.el.style.overflow = 'hidden';
			// Check if the element is being closed or is already closed
			if (this.isClosing || !this.el.open) {
				this.open();
				// Check if the element is being openned or is already open
			} else if (this.isExpanding || this.el.open) {
				this.shrink();
			}
		}

		// Function called to close the content with an animation
		shrink() {
			// Set the element as "being closed"
			this.isClosing = true;

			// Store the current height of the element
			const startHeight = `${this.el.offsetHeight}px`;
			// Calculate the height of the summary
			const endHeight = `${this.summary.offsetHeight}px`;

			// If there is already an animation running
			if (this.animation) {
				// Cancel the current animation
				this.animation.cancel();
			}

			// Start a WAAPI animation
			this.animation = this.el.animate({
				// Set the keyframes from the startHeight to endHeight
				height: [startHeight, endHeight]
			}, {
				// If the duration is too slow or fast, you can change it here
				duration: 400,
				// You can also change the ease of the animation
				easing: 'ease-out'
			});

			// When the animation is complete, call onAnimationFinish()
			this.animation.onfinish = () => this.onAnimationFinish(false);
			// If the animation is cancelled, isClosing variable is set to false
			this.animation.oncancel = () => this.isClosing = false;
		}

		// Function called to open the element after click
		open() {
			// Apply a fixed height on the element
			this.el.style.height = `${this.el.offsetHeight}px`;
			// Force the [open] attribute on the details element
			this.el.open = true;
			// Wait for the next frame to call the expand function
			window.requestAnimationFrame(() => this.expand());
		}

		// Function called to expand the content with an animation
		expand() {
			// Set the element as "being expanding"
			this.isExpanding = true;
			// Get the current fixed height of the element
			const startHeight = `${this.el.offsetHeight}px`;
			// Calculate the open height of the element (summary height + content height)
			const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

			// If there is already an animation running
			if (this.animation) {
				// Cancel the current animation
				this.animation.cancel();
			}

			// Start a WAAPI animation
			this.animation = this.el.animate({
				// Set the keyframes from the startHeight to endHeight
				height: [startHeight, endHeight]
			}, {
				// If the duration is too slow of fast, you can change it here
				duration: 400,
				// You can also change the ease of the animation
				easing: 'ease-in-out'
			});
			// When the animation is complete, call onAnimationFinish()
			this.animation.onfinish = () => this.onAnimationFinish(true);
			// If the animation is cancelled, isExpanding variable is set to false
			this.animation.oncancel = () => this.isExpanding = false;
		}

		// Callback when the shrink or expand animations are done
		onAnimationFinish(open) {
			// Set the open attribute based on the parameter
			this.el.open = open;
			// Clear the stored animation
			this.animation = null;
			// Reset isClosing & isExpanding
			this.isClosing = false;
			this.isExpanding = false;
			// Remove the overflow hidden and the fixed height
			this.el.style.height = this.el.style.overflow = '';
		}
	}
	document.querySelectorAll('details').forEach((el) => {
		el.addEventListener('click', () => {
			document.querySelectorAll('details').forEach((l) => {
				if (l.hasAttribute('open')) {
					if (l != el) {
						l.querySelector('summary').click()
					}
				}
			})
		})
		new Accordion(el);

	});

	$('.offer__carousel').slick({
		arrows: true,
		dots: false,
		infinite: true,
		centerMode: true,
		centerPadding: '0px',
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 20000,
		appendArrows: '.offer__buttons',
		responsive: [
			{
				breakpoint: 1520,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	});

	// $('.flota__nameSlider').slick({
	// 	arrows: false,
	// 	dots: false,
	// 	slidesToShow: 5,
	// 	slidesToScroll: 1,
	// 	asNavFor: '.flota__slider',
	// 	centerMode: true,
	// 	centerPadding: '0px',
	// 	focusOnSelect: true,
	// 	responsive: [
	// 		{
	// 			breakpoint: 768,
	// 			settings: {
	// 				slidesToShow: 1,
	// 			}
	// 		}
	// 	]
	// })
	$('.rewards__slider').slick({
		arrows: true,
		dots: false,
		slidesToShow: 5,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		nextArrow: '.rewards__left',
		prevArrow: '.rewards__right',
		responsive: [
			{
				breakpoint: 1300,
				settings: {
					slidesToShow: 4,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	});
	const btn = document.querySelector('.scrollTop');
	const header = document.querySelector('.header');
	const headerholder = document.querySelector('.headerHolder')

	window.onscroll = function () { scrollFunction() };

	function scrollFunction() {
		if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
			btn.style.display = "flex";
		} else {
			btn.style.display = "none";
		}
		if (document.body.scrollTop > 56 || document.documentElement.scrollTop > 56) {
			header.classList.add('scroll')
			headerholder.classList.add('active')
		} else {
			header.classList.remove('scroll')
			headerholder.classList.remove('active')
		}
	}

	function animateValue(obj, start, end, duration) {
		let startTimestamp = null;
		const step = (timestamp) => {
			if (!startTimestamp) startTimestamp = timestamp;
			const progress = Math.min((timestamp - startTimestamp) / duration, 1);
			obj.innerHTML = Math.floor(progress * (end - start) + start);
			if (progress < 1) {
				window.requestAnimationFrame(step);
			}
		};
		window.requestAnimationFrame(step);
	}
	if (document.querySelectorAll(".counter")) {
		document.addEventListener('aos:in', ({ detail }) => {
			const objs = document.querySelectorAll(".counter");
			objs.forEach(obj => {
				if(obj.parentElement == detail ){
					animateValue(obj, 0, parseInt(obj.dataset.max), 4000);
				}
			});
		});
	}
})


window.onload = () => {
	$('.flota__slider').slick({
		arrows: true,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		cssEase: 'linear',
		//	asNavFor: '.flota__nameSlider',
		nextArrow: '.flota__next',
		prevArrow: '.flota__prev',
	});
	$('.values__slider').slick({
		arrows: false,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		autoplay: true,
		autoplaySpeed: 2000,
		cssEase: 'linear',
	});
	const nexts = document.querySelectorAll('.values__slider .values__right');
	nexts.forEach(next => {
		next.addEventListener('click', () => {
			$('.values__slider').slick('slickPrev');
		})
	});
	const prevs = document.querySelectorAll('.values__slider .values__left');
	prevs.forEach(prev => {
		prev.addEventListener('click', () => {
			$('.values__slider').slick('slickNext');
		})
	});
}

